import React, { useState, useEffect, useContext } from 'react';
import './QuantitySelector.css';
import { ProductModalContext } from '../../../ProductModalContext';
import { withTranslation } from 'react-i18next';
import { QuantityDecClick, QuantityIncClick } from '../../../../../../../utils/Analytics';

const QuantitySelector = ({ title, sku, t }) => {
    const { currQty, setCurrQty } = useContext(ProductModalContext)

    useEffect(() => {
        
    }, [])

    const handleOnClick = (type) => {
        if(type==='dec' && currQty > 1){
            QuantityDecClick(title, sku);
            setCurrQty(currQty-1)
        }else if(type==='inc'){
            QuantityIncClick(title, sku);
            setCurrQty(currQty+1)
        }
    }

    return (
        <div id="qty-selector-column" className="flex-center" >
            <div className="title-container">{t('chooseQuantity')}</div>
            <div className="qty-container">
                <span onClick={() => handleOnClick('dec')} className={currQty > 1 ? `subtract` : `subtract disabled`}>-</span>
                <span className={`display-qty`}>{currQty}</span>
                <span onClick={() => handleOnClick('inc')} className={`addition`}>+</span>
            </div> 
        </div>
    );
}

export default withTranslation()(QuantitySelector);
